var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKpmgSendToVerifierConfirm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90.161,
    height: 71.812,
    viewBox: "0 0 90.161 71.812"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".kpmg-send-to-verifier-confirm_svg__cls-2{fill:none}.kpmg-send-to-verifier-confirm_svg__cls-5{fill:#fff}.kpmg-send-to-verifier-confirm_svg__cls-4,.kpmg-send-to-verifier-confirm_svg__cls-5{stroke:none}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kpmg-send-to-verifier-confirm_svg__ICN_Modal_confirmare_La_Verificat_Enabled",
    "data-name": "ICN_Modal confirmare La Verificat_Enabled",
    transform: "translate(-942.919 -396.389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kpmg-send-to-verifier-confirm_svg__Path_948",
    "data-name": "Path 948",
    d: "M44.5 13.39a4 4 0 016.929 0l41.11 63.81a4 4 0 01-3.465 6H6.926a4 4 0 01-3.465-6z",
    transform: "translate(940 385)",
    fill: "#1fb4ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-send-to-verifier-confirm_svg__ICN_Trimite_la_Aprobare_Enabled",
    "data-name": "ICN_Trimite la Aprobare_Enabled",
    transform: "translate(784 165.097)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-send-to-verifier-confirm_svg__Path_969",
    "data-name": "Path 969",
    className: "kpmg-send-to-verifier-confirm_svg__cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "kpmg-send-to-verifier-confirm_svg__cls-4",
    d: "M4.22 3.2c.367-3.31 3.173-4.577 5.349-1.221L20.828 18.9c1.774 2.638 1.074 3.81-1.272 4.746L3.425 31.075c-1.856.71-3.89-1.405-3.331-3.575z",
    transform: "rotate(43 -223.14 393.417)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "kpmg-send-to-verifier-confirm_svg__cls-5",
    d: "M6.787 1.6c-.375 0-.856.677-.977 1.771l-.005.046-.008.046L1.672 27.77l-.012.067-.016.066c-.157.605.142 1.079.278 1.254.215.278.51.457.751.457.05 0 .098-.007.146-.023l16.068-7.4.037-.017.039-.016c1.135-.453 1.255-.753 1.256-.755.001-.004.092-.406-.719-1.612l-.002-.003-.002-.004L8.237 2.861l-.005-.008-.005-.008C7.63 1.926 7.079 1.6 6.787 1.6m0-1.6c.892 0 1.89.599 2.782 1.975l11.259 16.924c1.774 2.638 1.074 3.81-1.272 4.746l-16.131 7.43c-.25.096-.503.14-.752.14-1.604 0-3.063-1.836-2.579-3.711L4.22 3.195C4.436 1.242 5.502 0 6.787 0z",
    transform: "rotate(43 -223.14 393.417)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-send-to-verifier-confirm_svg__Path_971",
    "data-name": "Path 971",
    d: "M1.287 1.672C1.335.037 3.064-1.006 3.7 1.5c0 0 2.349 8.414 2.641 9.835l-4.768 2.446c-2.245.977-1.721.641-1.557-.973z",
    transform: "rotate(43 -243.936 395.386)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-send-to-verifier-confirm_svg__Path_970",
    "data-name": "Path 970",
    className: "kpmg-send-to-verifier-confirm_svg__cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "kpmg-send-to-verifier-confirm_svg__cls-4",
    d: "M1.005 1.987C1.372.252 3.338-.875 5.514.884l3.548 3.847C11 5.843 10.322 5.7 7.976 6.2L1.144 7.966c-1.856.372-1.244.04-.684-1.1z",
    transform: "rotate(-148 142 117.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "kpmg-send-to-verifier-confirm_svg__cls-5",
    d: "M3.342 1.6c-.43 0-.672.343-.757.66L2.16 6.05l4.794-1.243-2.53-2.744c-.393-.3-.774-.463-1.083-.463m0-1.6C4 0 4.743.26 5.514.884l3.548 3.847c1.933 1.112 1.26.973-1.086 1.464l-6.832 1.77c-.482.097-.797.146-.99.146-.552 0-.11-.4.305-1.24l.546-4.884C1.242.867 2.146 0 3.342 0z",
    transform: "rotate(-148 142 117.86)"
  }))))));
}

export default SvgKpmgSendToVerifierConfirm;